import { Node_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1";
import { Decorations } from "../decorations";
import { TextNodeTransformer } from "../text-node-transformer";
import { TextStyleTransformer } from "../text-style-transformer";
import RicosTextualTheme from "../textual-theme/textual-theme";
import { RicosNodeStyle } from "./node-style";
import RicosTextNodeStyle from "./text-node-style";
import { RicosTextStyle } from "./text-style";
class RicosDocumentStyle {
  constructor(documentStyle) {
    this.documentStyle = documentStyle;
  }
  static fromNode(node) {
    return new RicosDocumentStyle(new TextNodeTransformer(node).toDocumentStyle());
  }
  static isNodeTransformable(node) {
    return node.type === Node_Type.PARAGRAPH || node.type === Node_Type.HEADING;
  }
  /**
   * Extracts given decoration settings for specific node type from the current Document Style.
   */
  getDecoration(nodeType, decorationType) {
    return Decorations.of(this.documentStyle[nodeType]?.decorations || []).byType(decorationType);
  }
  getDecorations(node) {
    const documentStyleKey = new TextNodeTransformer(node).getDocumentStyleKey();
    return Decorations.of(
      this.documentStyle[documentStyleKey]?.decorations || []
    ).toDecorationArray();
  }
  getTextStyle(nodeType) {
    return RicosTextStyle.of({ lineHeight: this.documentStyle[nodeType]?.lineHeight });
  }
  getNodeStyle(nodeType) {
    return RicosNodeStyle.of(this.documentStyle[nodeType]?.nodeStyle);
  }
  /**
   * Translates DocumentStyle to HTML style tag with CSS variable definitions
   */
  toStyleTag() {
    const theme = TextStyleTransformer.fromDocumentStyle(this.documentStyle).toTheme();
    return new RicosTextualTheme(theme).toStyleTag();
  }
  /**
   * Translates DocumentStyle entity to RichContent compatible DocumentStyle object
   */
  toContent() {
    return this.documentStyle;
  }
  /**
   * DocumentStyle modification
   */
  setStyle(nodeType, textNodeStyle) {
    const style = new RicosTextNodeStyle(this.documentStyle[nodeType] || { decorations: [] }).overrideWith(textNodeStyle).getTextNodeStyle();
    return new RicosDocumentStyle({ ...this.documentStyle, [nodeType]: style });
  }
  resetStyle(nodeType) {
    return new RicosDocumentStyle({ ...this.documentStyle, [nodeType]: {} });
  }
  /**
   * DocumentStyle modification
   */
  mergeWith(documentStyle) {
    return Object.entries(documentStyle).reduce(
      (acc, [key, style]) => acc.setStyle(key, style),
      new RicosDocumentStyle(this.documentStyle)
    );
  }
}
export {
  RicosDocumentStyle
};
//# sourceMappingURL=document-style.js.map
